import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  @media (hover: hover) {\n    &:hover ",
        " {\n      ",
        "\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { Box, Link, Button, ArrowDown, useWindowSize } from "@miro-site/core";
import { theme as defaultTheme } from "@miro-site/design-tokens";
var AccordionContainer = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "nav",
        $styles: {
            maxWidth: theme.header ? theme.header.container.maxWidth : null
        },
        $pl: theme.accordion.gutter,
        $pr: theme.accordion.gutter,
        $mx: "auto"
    };
}).withConfig({
    componentId: "sc-7972f3fb-0"
})(_templateObject());
var AccordionItem = styled(Box).attrs({
    as: "li"
}).withConfig({
    componentId: "sc-7972f3fb-1"
})(_templateObject1(), function(props) {
    return props.theme.normalizeStyles(props.theme.accordion.itemStyles);
});
var AccordionCategory = styled(Box).attrs(function(param) {
    var $isActive = param.$isActive, theme = param.theme;
    return {
        $styles: {
            display: [
                "block",
                "inline-block"
            ],
            fontSize: theme.accordion.category.fontSize,
            fontWeight: theme.accordion.category.fontWeight,
            lineHeight: theme.accordion.category.lineHeight,
            color: $isActive ? defaultTheme.colors.outspoken : defaultTheme.colors.primaryWhite,
            borderBottom: "1px solid transparent",
            transition: "250ms ease",
            transitionProperty: "color, border-color"
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-2"
})(_templateObject2());
var AccordionCategoryWrapper = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $styles: {
            position: "relative",
            cursor: "pointer"
        },
        $py: theme.accordion.categoryWrapper.padding
    };
}).withConfig({
    componentId: "sc-7972f3fb-3"
})(_templateObject3(), AccordionCategory, function(props) {
    return props.theme.normalizeStyles({
        color: defaultTheme.colors.outspoken,
        borderColor: defaultTheme.colors.outspoken
    });
});
var AccordionButton = styled(Button).attrs(function(props) {
    return {
        $styles: {
            display: "block",
            ":focus": _object_spread({}, props.theme.focus.outlines.withOffset)
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-4"
})(_templateObject4());
var AccordionLink = styled(Link).attrs(function(props) {
    return {
        $styles: {
            display: [
                "block",
                "inline-block"
            ],
            ":focus": _object_spread({}, props.theme.focus.outlines.withOffset)
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-5"
})(_templateObject5());
var AccordionInnerLink = styled(Link).attrs(function(props) {
    return {
        $styles: {
            fontSize: props.theme.accordion.innerLink.fontSize,
            lineHeight: props.theme.accordion.innerLink.lineHeight,
            position: "relative",
            ":after": {
                content: "''",
                background: "#211D45",
                position: "absolute",
                top: -12,
                left: -15,
                right: -45,
                bottom: -12,
                borderRadius: 8,
                opacity: 0,
                transition: "opacity 250ms ease"
            },
            ":focus": _object_spread({}, props.theme.focus.outlines.withOffset),
            "@media (hover: hover)": {
                ":hover:after": {
                    opacity: 1
                }
            }
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-6"
})(_templateObject6());
var AccordionSubcategoryContainer = styled(Box).attrs(function(param) {
    var $isActive = param.$isActive;
    return {
        $styles: {
            visibility: $isActive ? "visible" : "hidden",
            overflow: "hidden",
            transition: "400ms ease",
            transitionProperty: "height, visibility"
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-7"
})(_templateObject7());
var AccordionSubcategoryWrapper = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $pl: theme.accordion.subcategoryWrapper.padding.left,
        $pb: theme.accordion.subcategoryWrapper.padding.bottom
    };
}).withConfig({
    componentId: "sc-7972f3fb-8"
})(_templateObject8());
var AccordionSubcategory = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "h4",
        $styles: {
            fontSize: theme.accordion.subcategory.fontSize,
            lineHeight: theme.accordion.subcategory.lineHeight,
            fontWeight: theme.accordion.subcategory.fontWeight,
            color: theme.accordion.subcategory.color
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-9"
})(_templateObject9());
var AccordionInnerList = styled(Box).attrs(function(param) {
    var theme = param.theme, $isOffset = param.$isOffset;
    return {
        as: "ul",
        $mt: $isOffset ? theme.accordion.innerList.margin.top : null
    };
}).withConfig({
    componentId: "sc-7972f3fb-10"
})(_templateObject10());
var AccordionInnerItem = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "li",
        $mt: theme.accordion.innerItem.margin.top
    };
}).withConfig({
    componentId: "sc-7972f3fb-11"
})(_templateObject11());
var AccordionLinkDescription = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        $styles: {
            fontSize: theme.accordion.description.fontSize,
            lineHeight: theme.accordion.description.lineHeight,
            color: theme.accordion.description.color,
            opacity: theme.accordion.description.opacity
        },
        $mt: theme.accordion.description.margin.top
    };
}).withConfig({
    componentId: "sc-7972f3fb-12"
})(_templateObject12());
var AccordionAdditionalLink = styled(Link).attrs(function(param) {
    var theme = param.theme;
    return {
        $mt: theme.accordion.additionalLink.margin.top
    };
}).withConfig({
    componentId: "sc-7972f3fb-13"
})(_templateObject13());
var AccordionIcon = styled(Box).attrs(function(param) {
    var $isActive = param.$isActive;
    return {
        $styles: {
            position: "absolute",
            top: "50%",
            right: 0,
            transform: $isActive ? "translateY(-50%) scaleY(-1)" : "translateY(-50%) scaleY(1)",
            transition: "transform 250ms ease"
        }
    };
}).withConfig({
    componentId: "sc-7972f3fb-14"
})(_templateObject14());
var AccordionMenu = function(props) {
    var categories = props.categories;
    var ref = useState(categories.reduce(function(acc, c, i) {
        acc[i] = false;
        return acc;
    }, [])), expandedItems = ref[0], setExpandedItems = ref[1];
    var ref1 = useWindowSize(), width = ref1.width, height = ref1.height;
    var linkRefs = useRef([]);
    var containerRefs = useRef([]);
    useEffect(function() {
        containerRefs.current.forEach(function(container, i) {
            var ref;
            if (!container) {
                return;
            }
            container.style.height = expandedItems[i] ? "".concat(((ref = container.firstChild) === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0, "px") : "0px";
        });
    }, [
        expandedItems,
        height,
        width
    ]);
    return /*#__PURE__*/ _jsx(AccordionContainer, {
        "aria-label": "Accordion menu",
        className: props.className,
        children: /*#__PURE__*/ _jsx("ul", {
            children: categories.map(function(category, categoryIndex) {
                return /*#__PURE__*/ _jsxs(AccordionItem, {
                    children: [
                        category.path ? /*#__PURE__*/ _jsx(AccordionCategoryWrapper, {
                            onClick: function() {
                                var link = linkRefs.current[categoryIndex];
                                if (link !== null) {
                                    link.click();
                                }
                            },
                            children: /*#__PURE__*/ _jsx(AccordionLink, {
                                ref: function(ref) {
                                    linkRefs.current[categoryIndex] = ref;
                                },
                                href: category.path,
                                children: /*#__PURE__*/ _jsx(AccordionCategory, {
                                    children: category.title
                                })
                            })
                        }) : /*#__PURE__*/ _jsxs(AccordionCategoryWrapper, {
                            onClick: function() {
                                return setExpandedItems(_object_spread_props(_object_spread({}, expandedItems), _define_property({}, categoryIndex, !expandedItems[categoryIndex])));
                            },
                            children: [
                                /*#__PURE__*/ _jsx(AccordionButton, {
                                    "aria-expanded": expandedItems[categoryIndex],
                                    children: /*#__PURE__*/ _jsx(AccordionCategory, {
                                        $isActive: expandedItems[categoryIndex],
                                        children: category.title
                                    })
                                }),
                                /*#__PURE__*/ _jsx(AccordionIcon, {
                                    $isActive: expandedItems[categoryIndex],
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ _jsx(ArrowDown, {})
                                })
                            ]
                        }),
                        category.groups && /*#__PURE__*/ _jsx(AccordionSubcategoryContainer, {
                            ref: function(ref) {
                                containerRefs.current[categoryIndex] = ref;
                            },
                            $isActive: expandedItems[categoryIndex],
                            "aria-hidden": !expandedItems[categoryIndex],
                            children: /*#__PURE__*/ _jsx("div", {
                                children: category.groups.map(function(subcategory, subcategoryIndex) {
                                    return /*#__PURE__*/ _jsxs(AccordionSubcategoryWrapper, {
                                        children: [
                                            subcategory.title && /*#__PURE__*/ _jsx(AccordionSubcategory, {
                                                children: subcategory.title
                                            }),
                                            /*#__PURE__*/ _jsx(AccordionInnerList, {
                                                $isOffset: !!subcategory.title,
                                                children: subcategory.items.map(function(link, linkIndex) {
                                                    return /*#__PURE__*/ _jsx(AccordionInnerItem, {
                                                        children: /*#__PURE__*/ _jsx(AccordionInnerLink, {
                                                            href: link.path,
                                                            $color: "white",
                                                            $size: "medium",
                                                            children: /*#__PURE__*/ _jsxs(Box, {
                                                                $styles: {
                                                                    position: "relative",
                                                                    zIndex: 2
                                                                },
                                                                children: [
                                                                    link.title,
                                                                    link.description && /*#__PURE__*/ _jsx(AccordionLinkDescription, {
                                                                        children: link.description
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }, linkIndex);
                                                })
                                            }),
                                            subcategory.viewAllLink && /*#__PURE__*/ _jsx(AccordionAdditionalLink, {
                                                $variant: "regular",
                                                $color: "white",
                                                $size: "medium",
                                                withArrow: true,
                                                href: subcategory.viewAllLink.path,
                                                children: subcategory.viewAllLink.title
                                            })
                                        ]
                                    }, subcategoryIndex);
                                })
                            })
                        })
                    ]
                }, categoryIndex);
            })
        })
    });
};
export default AccordionMenu;
